export const GRID_ZOOM_PRESETS = Object.freeze([1, 1.5, 2, 3, 4, 5]);
export const GRID_ZOOM_STEP = 0.01;

export const clampGridZoom = (zoom) => {
  const numericZoom = Number(zoom);
  const validZoom = Number.isFinite(numericZoom) ? numericZoom : 1;
  return Math.max(1, Math.min(5, Math.round(validZoom * 100) / 100));
};

export const getAdjacentGridZoomPreset = (zoom, direction) => {
  const currentZoom = clampGridZoom(zoom);
  if (direction >= 0) {
    return GRID_ZOOM_PRESETS.find((preset) => preset > currentZoom + 1e-8) || 5;
  }

  return [...GRID_ZOOM_PRESETS].reverse().find((preset) => preset < currentZoom - 1e-8) || 1;
};